import React from 'react';
import './Button.css';

const Button = ({
  label,
  onClick,
  type = 'button',
  variant = 'primary',
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`feedbackBtn ${variant} ${className}`}
      disabled={disabled}
      {...props}
    >
      {label}
    </button>
  );
};

export default Button;
